import { _ } from 'wgnet-awesomejs';

import BaseInput from 'source/lib/component/input/base';

import template from './template.html';

const PATTERNS = {
    digit: /[^\d]+/gi,
    letterdigit: /[^\da-zA-Z]+/gi,
};
const KEY_FILTERS = {
    digit(key) {
        return key > 47 && key < 58;
    },
    letterdigit(key) {
        return (key > 47 && key < 58) || (key > 64 && key < 91);
    },
};
const CLEANED_ERROR_CODES = [
    'banned',
    'invalid_credentials',
    'invalid',
    'unauthorized',
];
const TwoFactorInput = BaseInput.extend({
    name: 'twofactor-input',
    template,
    initialize(options = {}) {
        _.extend(this.events, {
            keydown: 'keydown',
            input: 'input',
        });
        this.pattern = PATTERNS[options.keyFilterMode || 'digit'];
        this.keyFilter = KEY_FILTERS[options.keyFilterMode || 'digit'];
        BaseInput.prototype.initialize.call(this, options);
    },
    input(event) {
        const { target } = event;
        let value = target.value.replace(this.pattern, '');
        if (value.length > this.data.maxlength) {
            value = value.substring(0, this.data.maxlength);
        }
        if (value !== target.value) {
            target.value = value;
        }
    },
    keyup(event = {}) {
        if (this.keyIsEnabled(event)) {
            if (!(event.ctrlKey || event.shiftKey)) {
                BaseInput.prototype.keyup.call(this, event);
            }
            return true;
        }
        return false;
    },
    keydown(event = {}) {
        const key = event.which || event.keyCode;
        if (key === 13) {
            this.$el.trigger('submit');
            return false;
        }
        return this.keyIsEnabled(event);
    },
    keyIsEnabled(event = {}) {
        const key = event.which || event.keyCode;

        // allow ctrl + x|v|a|z
        if (
            (event.metaKey || event.ctrlKey) && [
                90, // z
                86, // v
                88, // x
                65, // a
            ].includes(key)
        ) {
            return true;
        }

        if (this.keyFilter(key)
            || _.contains([46, 8, 9, 27, 13], key)
            || event.ctrlKey || (key >= 35 && key <= 39)
            || (event.shiftKey && key === 45)) {
            return true;
        }
        if ((event.shiftKey && (key < 48 || key > 57))
            || (key < 96 || key > 105)
            || (event.altKey && key > 95 && key < 106)) {
            event.preventDefault();
            return false;
        }
        return true;
    },
    onErrorUpdate(event = {}, ...args) {
        const errors = _.extract(event, 'responseJSON.errors.__all__', []);
        if (_.contains(CLEANED_ERROR_CODES, errors[0])) {
            this.setValue('');
        }
        BaseInput.prototype.onErrorUpdate.call(this, event, ...args);
    },
});

export default TwoFactorInput;
